export default "__VITE_ASSET__BEXjWvHu__"